import React,{useContext} from 'react';
import styles from "./Transctions.module.css"
import ExpenseList from '../Transctions'
import noteContext from '../Context/NoteContext';
export default function Transctions(){

      const {
        expenseList, setExpenseList,
        categories, setCategories,
        isModal, setisModal,
        modalType, setModalType,
        edittmp, setedittmp,
        ind, setind,
        allCat, setAllCat,
        addExpense, deleteExpense, updateExpense,
        openModal, closeModal, setmodalTypeAndOpen
    } = useContext(noteContext);
    
    return(
            <>
            <div className={styles.expenseList}>
            <ExpenseList/>
            </div>
            </>
    )
}

